import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import coffee from "./modules/coffee";
import income from "./modules/income";
import expenses from "./modules/expenses";
import report from "./modules/report";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    coffee,
    income,
    expenses,
    report,
  },
});
